var targetParent = $(".footer--root .footer--sub");

// Create the new block
var newBlock = $(".footer--root .footer--blocks .footer--block");

// Insert the new block as the last child of the target parent
targetParent.append(newBlock);